export default __webpack_public_path__ + "static/media/Visa.a2acba33.svg";